import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'

type JwtPayload = {
  exp?: number
  nbf?: number
  [key: string]: any
}

/**
 * Validates the JWT by checking `exp` and `nbf` claims.
 * Optionally auto-clears the cookie if expired.
 */
export function isJwtValid(token?: string, clearIfInvalid = false): boolean {
  try {
    token = token || Cookies.get('token')
    if (!token) return false

    const decoded: JwtPayload = jwtDecode(token)
    const now = Math.floor(Date.now() / 1000)

    if (decoded.exp && decoded.exp < now) {
      console.log('[JWT] Token expired.')
      if (clearIfInvalid) Cookies.remove('token')
      return false
    }

    if (decoded.nbf && decoded.nbf > now) {
      console.log('[JWT] Token not yet valid.')
      if (clearIfInvalid) Cookies.remove('token')
      return false
    }

    return true
  } catch (e) {
    console.log('[JWT] Invalid format:', e)
    if (clearIfInvalid) Cookies.remove('token')
    return false
  }
}
